import { Form, useSearchParams, useSubmit } from 'react-router'
import { Icon } from '#app/components/ui/icon.tsx'
import {
	InputGroup,
	InputGroupAddon,
	InputGroupInput,
} from '#app/components/ui/input-group.tsx'
import { Spinner } from '#app/components/ui/spinner.tsx'
import { useDebounce, useIsPending } from '#app/utils/misc.tsx'

export function RentalSearch({ total }: { total: number }) {
	const [searchParams] = useSearchParams()
	const submit = useSubmit()
	const isSearching = useIsPending({ formMethod: 'GET' })

	const handleFormChange = useDebounce(async (form: HTMLFormElement) => {
		await submit(form, { replace: true, preventScrollReset: true })
	}, 350)

	const defaultValue = searchParams.get('q') ?? ''

	return (
		<Form
			method="GET"
			role="search"
			onChange={(e) => handleFormChange(e.currentTarget)}
		>
			<input type="hidden" name="page" value="1" />
			<InputGroup aria-busy={isSearching} className="overflow-hidden">
				<InputGroupAddon>
					<Icon name="magnifying-glass" className="size-4" />
				</InputGroupAddon>
				<InputGroupInput
					name="q"
					defaultValue={defaultValue}
					placeholder="Search rentals..."
					aria-label="Search rentals"
					className="w-full"
				/>
				<InputGroupAddon align="inline-end">
					{`${total} results`}
				</InputGroupAddon>
			</InputGroup>
		</Form>
	)
}
